




import Vue from 'vue'
import ClipboardJS from 'clipboard'

export default Vue.extend({
  name: 'ClipboardText',
  props: {
    text: {
      type: String,
      required: true,
    },
    /* Use a custom id if more than one clipboard lives on a page to avoid multiple targeting */
    id: {
      type: String,
      default: 'text',
    },
    suppressStyles: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      clipboard: null,
    }
  },

  mounted() {
    this.clipboard = new ClipboardJS(`#${this.id}`)
    this.clipboard.on('success', (e: any) => {
      // @ts-ignore
      this.$messaging.showSuccess('Copied to your clipboard!')
      e.clearSelection()
    })
  },

  beforeDestroy() {
    this.clipboard.destroy()
  },
})
